(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function updateQty(index, change) {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    const input = inputs[index];
    const newValue = parseInt(input.value) + change;
    if (newValue >= 0) {
      input.value = newValue;
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (form) {
      const updateBtn = form.querySelector('button[name="update"]');
      if (updateBtn) {
        updateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          form.submit();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var btn = document.getElementById('tw-back-to-top');
    if (btn) {
      function toggle() { btn.classList.toggle('tw-opacity-100', window.scrollY > 400); btn.classList.toggle('tw-pointer-events-auto', window.scrollY > 400); }
      window.addEventListener('scroll', toggle);
      toggle();
      btn.addEventListener('click', function(e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }

    // Pestañas / Acordeón Footer Mobile
    document.querySelectorAll('.tw-footer__heading').forEach(function(heading) {
      heading.addEventListener('click', function() {
        if (window.innerWidth < 768) {
          var block = this.closest('.tw-footer__block');
          var isActive = block.classList.contains('is-active');
          
          // Opcional: Cerrar otros (comenta si quieres que se puedan abrir varios)
          // document.querySelectorAll('.tw-footer__block').forEach(function(b) { b.classList.remove('is-active'); });

          if (!isActive) {
            block.classList.add('is-active');
          } else {
            block.classList.remove('is-active');
          }
        }
      });
    });

    // En mobile, si por alguna razón un bloque no tiene heading, no lo colapsamos.
    function ensureHeadlessBlocksAreOpen() {
      if (window.innerWidth >= 768) return;
      document.querySelectorAll('.tw-footer__block').forEach(function(block) {
        if (!block.querySelector('.tw-footer__heading') && block.querySelector('.tw-footer__content')) {
          block.classList.add('is-active');
        }
      });
    }

    // En mobile, abrimos por defecto "Info tienda" (store_info) para que siempre se vea completo.
    function openStoreInfoByDefault() {
      if (window.innerWidth >= 768) return;
      document.querySelectorAll('.tw-footer__block--store-info').forEach(function(block) {
        if (block.querySelector('.tw-footer__content')) block.classList.add('is-active');
      });
    }
    ensureHeadlessBlocksAreOpen();
    openStoreInfoByDefault();
    window.addEventListener('resize', ensureHeadlessBlocksAreOpen);
    window.addEventListener('resize', openStoreInfoByDefault);

    document.querySelectorAll('#FooterCountryForm select[data-submit], #FooterLanguageForm select[data-submit]').forEach(function(el) {
      el.addEventListener('change', function() { this.form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-age-verifier"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var key = 'tw_age_verified';
    if (document.cookie.indexOf(key + '=1') !== -1) return;
    var el = document.querySelector('[data-tw-age-verifier]');
    if (!el) return;
    el.classList.remove('tw-hidden');
    el.setAttribute('aria-hidden', 'false');
    el.querySelector('[data-tw-age-approve]') && el.querySelector('[data-tw-age-approve]').addEventListener('click', function() {
      document.cookie = key + '=1; path=/; max-age=31536000';
      el.classList.add('tw-hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    el.querySelector('[data-tw-age-decline]') && el.querySelector('[data-tw-age-decline]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__content').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__decline').classList.remove('tw-hidden');
    });
    el.querySelector('[data-tw-age-return]') && el.querySelector('[data-tw-age-return]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__decline').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__content').classList.remove('tw-hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cart-upsell--fetch').forEach(function(el) {
      if (!el.dataset.url) return;
      var track = el.querySelector('[data-upsell-track]');
      if (!track) return;
      fetch(el.dataset.url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
          var remote = wrap.querySelector('#shopify-section-' + sectionId + ' [data-upsell-track]');
          if (!remote) remote = wrap.querySelector('[data-upsell-track]');
          if (remote && remote.children.length > 0) {
            track.innerHTML = remote.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function() { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-grid"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const swiperEl = document.querySelector('[data-cg-swiper]');
      if (!swiperEl) return;
      const root = swiperEl.closest('section[data-section-id]');
      if (!root) return;
      const SECTION_ID = root.getAttribute('data-section-id');

      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      const init = () => {
        if (!window.Swiper) return false;

        const prev = swiperEl.querySelector('[data-cg-prev]');
        const next = swiperEl.querySelector('[data-cg-next]');
        const pagination = swiperEl.querySelector('[data-cg-pagination]');

        const spvM = parseFloat(swiperEl.getAttribute('data-spv-m') || 1);
        const spvT = parseFloat(swiperEl.getAttribute('data-spv-t') || 2);
        const spvD = parseFloat(swiperEl.getAttribute('data-spv-d') || 3);
        const gap = Number(swiperEl.getAttribute('data-gap') || 16);

        const loop = toBool(swiperEl.getAttribute('data-loop'));
        const autoplayEnabled = toBool(swiperEl.getAttribute('data-autoplay'));
        const speed = Number(swiperEl.getAttribute('data-speed') || 3000);
        const effect = swiperEl.getAttribute('data-effect') || 'slide';
        const speedTransition = Number(swiperEl.getAttribute('data-speed-transition') || 300);
        const centered = toBool(swiperEl.getAttribute('data-centered'));
        const grab = toBool(swiperEl.getAttribute('data-grab'));
        const freeMode = toBool(swiperEl.getAttribute('data-free-mode'));
        const pauseOnHover = toBool(swiperEl.getAttribute('data-pause-on-hover'));

        if (swiperEl.__twSwiper) {
          try { swiperEl.__twSwiper.destroy(true, true); } catch(e) {}
          swiperEl.__twSwiper = null;
        }

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered },
            1024: { slidesPerView: spvD, centeredSlides: centered }
          }
        };

        // Navigation
        if (prev && next) {
          cfg.navigation = { prevEl: prev, nextEl: next };
        }

        // Pagination
        if (pagination) {
          cfg.pagination = {
            el: pagination,
            clickable: true,
            dynamicBullets: false
          };
        }

        // Autoplay
        if (autoplayEnabled) {
          cfg.autoplay = {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover
          };
        }

        // Effect-specific settings
        if (effect === 'fade') {
          cfg.fadeEffect = { crossFade: true };
        } else if (effect === 'cube') {
          cfg.cubeEffect = {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          };
        } else if (effect === 'coverflow') {
          cfg.coverflowEffect = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          };
        } else if (effect === 'flip') {
          cfg.flipEffect = {
            slideShadows: true,
            limitRotation: true
          };
        }

        swiperEl.__twSwiper = new window.Swiper(swiperEl, cfg);
        return true;
      };

      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (init() || tries > 40) clearInterval(t);
      }, 100);

      document.addEventListener('shopify:section:load', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-libro-reclamaciones"] && !Shopify.designMode) return;
  try {
    
  function initLibroReclamacionesDate() {
    document.querySelectorAll('.lr-current-date').forEach(function (el) {
      var loc = el.getAttribute('data-locale') || 'es-ES';
      var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var today = new Date().toLocaleDateString(loc, dateOptions);
      today = today.charAt(0).toUpperCase() + today.slice(1);
      today = today.replace(/,/g, '');
      el.textContent = today;
    });
  }
  document.addEventListener('DOMContentLoaded', initLibroReclamacionesDate);
  document.addEventListener('shopify:section:load', initLibroReclamacionesDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticleSwiper(root) {
      if (!root) return;
      var el = root.querySelector('[data-tw-article-swiper]');
      if (!el || typeof window.Swiper === 'undefined') return;
      if (el._twArticleSwiper) {
        try {
          el._twArticleSwiper.destroy(true, true);
        } catch (e) {}
        el._twArticleSwiper = null;
      }
      var prev = root.querySelector('[data-tw-article-prev]');
      var next = root.querySelector('[data-tw-article-next]');
      var pagination = root.querySelector('[data-tw-article-pagination]');
      var cfg = {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      };
      if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
      if (pagination) cfg.pagination = { el: pagination, clickable: true };
      el._twArticleSwiper = new window.Swiper(el, cfg);
      [80, 250, 500].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (el._twArticleSwiper) el._twArticleSwiper.update();
          } catch (e) {}
        }, ms);
      });
    }
    function bootAll() {
      document.querySelectorAll('[data-tw-article-root]').forEach(function (root) {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (typeof window.Swiper !== 'undefined') {
            initArticleSwiper(root);
            clearInterval(timer);
          } else if (tries > 50) clearInterval(timer);
        }, 100);
      });
    }
    function bootOne(sectionId) {
      var root = document.querySelector('[data-tw-article-root="' + sectionId + '"]');
      if (!root) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof window.Swiper !== 'undefined') {
          initArticleSwiper(root);
          clearInterval(timer);
        } else if (tries > 50) clearInterval(timer);
      }, 100);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      setTimeout(function () {
        bootOne(String(e.detail.sectionId));
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__twMainCollectionToolbar) return;
  window.__twMainCollectionToolbar = true;

  function syncBodyScroll() {
    var open = document.querySelector('[data-tw-sidebar-overlay].is-open');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function openDrawer(root) {
    var overlay = root.querySelector('[data-tw-sidebar-overlay]');
    var panel = root.querySelector('[data-tw-drawer-panel]');
    var btn = root.querySelector('[data-tw-sidebar-open]');
    if (overlay) {
      overlay.classList.add('is-open');
      overlay.classList.remove('tw-pointer-events-none', 'tw-opacity-0');
      overlay.setAttribute('aria-hidden', 'false');
    }
    if (panel) {
      panel.classList.add('is-open');
      panel.classList.remove('-tw-translate-x-full');
    }
    if (btn) btn.setAttribute('aria-expanded', 'true');
    // Body state is used by CSS to resolve header/stacking context while the drawer is open.
    document.body.classList.add('tw-filter-drawer-open');
    syncBodyScroll();
  }

  function closeDrawer(root) {
    var overlay = root.querySelector('[data-tw-sidebar-overlay]');
    var panel = root.querySelector('[data-tw-drawer-panel]');
    var btn = root.querySelector('[data-tw-sidebar-open]');
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.classList.add('tw-pointer-events-none', 'tw-opacity-0');
      overlay.setAttribute('aria-hidden', 'true');
    }
    if (panel) {
      panel.classList.remove('is-open');
      panel.classList.add('-tw-translate-x-full');
    }
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('tw-filter-drawer-open');
    syncBodyScroll();
  }

  // Delegación global: el botón puede ser reemplazado por AJAX
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest && e.target.closest('[data-tw-sidebar-open]');
    if (openBtn) {
      var root = openBtn.closest('[data-tw-collection-root]');
      if (root) {
        e.preventDefault();
        openDrawer(root);
      }
      return;
    }
    var closeBtn = e.target.closest && e.target.closest('[data-tw-sidebar-close]');
    if (closeBtn) {
      var rootC = closeBtn.closest('[data-tw-collection-root]');
      if (rootC) {
        e.preventDefault();
        closeDrawer(rootC);
      }
      return;
    }
    var overlayHit = e.target.closest && e.target.closest('[data-tw-sidebar-overlay]');
    if (overlayHit && overlayHit.classList.contains('is-open')) {
      var rootO = overlayHit.closest('[data-tw-collection-root]');
      if (rootO) closeDrawer(rootO);
      return;
    }
    var viewBtn = e.target.closest && e.target.closest('.tw-collection-toolbar__views [data-tw-view]');
    if (viewBtn) {
      e.preventDefault();
      var rootV = viewBtn.closest('[data-tw-collection-root]');
      if (!rootV || rootV.getAttribute('data-enable-view-toggle') !== 'true') return;
      var v = viewBtn.getAttribute('data-tw-view');
      var mode = v === 'list' ? 'list' : v.replace(/^grid-/, '');
      twApplyCollectionView(rootV, mode);
    }
  });

  document.addEventListener('change', function(e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('select[name="sort_by"]')) return;
    var form = sel.closest('.tw-main-collection__sort-form');
    if (form) form.submit();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      if (overlay && overlay.classList.contains('is-open')) closeDrawer(root);
    });
  });

  // Resize handler - clean body class on viewport change
  (function() {
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        document.body.classList.remove('tw-filter-drawer-open');
      }, 150);
    });
  })();

  // View toggle
  function twClampGridCols(n) {
    n = parseInt(n, 10);
    if (!isFinite(n)) return 4;
    return Math.min(4, Math.max(2, n));
  }
  function twDefaultGridCols(root) {
    return String(twClampGridCols(root.getAttribute('data-cols-desktop-default')));
  }
  function twNormalizeCollectionView(saved, root) {
    if (saved === 'list') return 'list';
    if (saved === '2' || saved === '3' || saved === '4') return saved;
    if (saved === 'grid') return twDefaultGridCols(root);
    return null;
  }
  function twSyncCollectionViewButtons(root, mode) {
    var group = root.querySelector('.tw-collection-toolbar__views');
    if (!group) return;
    group.querySelectorAll('[data-tw-view]').forEach(function(b) {
      var v = b.getAttribute('data-tw-view');
      var on = v === 'list' ? mode === 'list' : mode !== 'list' && v === 'grid-' + mode;
      b.classList.toggle('tw-collection-view-btn--active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function twApplyCollectionView(root, mode) {
    if (!root || !mode) return;
    var storageKey = 'tw-collection-view-' + root.getAttribute('data-section-id');
    if (mode === 'list') {
      root.classList.add('tw-main-collection--list');
      root.style.removeProperty('--mcp-cols-m');
      root.style.removeProperty('--mcp-cols-t');
      root.style.removeProperty('--mcp-cols-d');
    } else {
      root.classList.remove('tw-main-collection--list');
      var n = String(twClampGridCols(mode));
      root.style.setProperty('--mcp-cols-m', n);
      root.style.setProperty('--mcp-cols-t', n);
      root.style.setProperty('--mcp-cols-d', n);
      mode = n;
    }
    try { sessionStorage.setItem(storageKey, mode === 'list' ? 'list' : mode); } catch (err) {}
    twSyncCollectionViewButtons(root, mode);
  }

  function restoreCollectionViews() {
    document.querySelectorAll('[data-tw-collection-root][data-enable-view-toggle="true"]').forEach(function(root) {
      var sectionId = root.getAttribute('data-section-id');
      var saved = null;
      try { saved = sessionStorage.getItem('tw-collection-view-' + sectionId); } catch (err) {}
      var mode = twNormalizeCollectionView(saved, root);
      if (mode == null) return;
      twApplyCollectionView(root, mode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCollectionViews);
  } else {
    restoreCollectionViews();
  }
  document.addEventListener('shopify:section:load', restoreCollectionViews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('section[id^="tw-main-product-"]');
    if (!sections.length) { console.log('[TW Sticky] No tw-main-product section found'); return; }
    sections.forEach(function(sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id.replace('tw-main-product-', '');
      if (!sectionId) return;
      var form = document.getElementById('product-form-' + sectionId);
      if (!form) return;
      if (sectionEl.dataset.twMainProductInitialized === '1') return;
      sectionEl.dataset.twMainProductInitialized = '1';
    const productJson = sectionEl.querySelector('[data-product-json]');
    const variantPricesJson = sectionEl.querySelector('[data-variant-prices]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;
    const variantPrices = variantPricesJson ? JSON.parse(variantPricesJson.textContent) : {};
    if (!product) return;

    function judgeMeBadgeHasReviews(badge) {
      const previousBadge = badge.querySelector('.jdgm-prev-badge') || badge;
      const reviewCount = parseInt(previousBadge.getAttribute('data-number-of-reviews') || '', 10);
      if (!Number.isNaN(reviewCount)) return reviewCount > 0;
      const averageRating = parseFloat(previousBadge.getAttribute('data-average-rating') || '');
      if (!Number.isNaN(averageRating)) return averageRating > 0;
      if (badge.querySelector('.jdgm-star.jdgm--on, .jdgm-star.jdgm--half')) return true;
      const text = (badge.textContent || '').trim().toLowerCase();
      if (!text) return false;
      if (text.indexOf('no review') !== -1 || text.indexOf('sin rese') !== -1) return false;
      return badge.querySelectorAll('.jdgm-star').length > 0;
    }

    function syncJudgeMeReviewBadges() {
      sectionEl.querySelectorAll('[data-product-app-block]').forEach(function(wrapper) {
        const badge = wrapper.querySelector('.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge, .jdgm-prev-badge');
        if (!badge) {
          wrapper.removeAttribute('data-review-widget-empty');
          return;
        }
        wrapper.dataset.reviewWidgetEmpty = judgeMeBadgeHasReviews(badge) ? 'false' : 'true';
      });
    }

    syncJudgeMeReviewBadges();
    [100, 500, 1200, 2500].forEach(function(delay) {
      window.setTimeout(syncJudgeMeReviewBadges, delay);
    });
    if (window.MutationObserver) {
      const judgeMeObserver = new MutationObserver(syncJudgeMeReviewBadges);
      judgeMeObserver.observe(sectionEl, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'data-average-rating', 'data-number-of-reviews']
      });
    }

    const hiddenId = form.querySelector('input[name="id"]');
    const priceEl = document.getElementById('price-' + sectionId);
    const submitBtn = sectionEl.querySelector('.tw-pdp-buy-buttons__add') || sectionEl.querySelector('button[type="submit"][name="add"]');
    const addToCartLabel = submitBtn && submitBtn.getAttribute('data-add-to-cart');
    const soldOutLabel = submitBtn && submitBtn.getAttribute('data-sold-out');
    const variantOptions = sectionEl.querySelectorAll('.tw-variant-option');

    function setSelectedLabels(opts) {
      // Update inline label: "Option: Value" (e.g. "Talla: 11")
      sectionEl.querySelectorAll('.tw-variant-selected-value').forEach(function (el) {
        var label = el.closest('label');
        if (!label) return;
        var forAttr = label.getAttribute('for') || '';
        var m = forAttr.match(/-option-(\d+)/);
        var pos = m ? parseInt(m[1], 10) : NaN;
        if (!pos || Number.isNaN(pos)) return;
        el.textContent = (opts && opts[pos - 1]) ? opts[pos - 1] : '';
      });
    }

    function getSelectedOptions() {
      const byPosition = {};
      variantOptions.forEach(function(el) {
        const pos = parseInt(el.getAttribute('data-option-position'), 10) || 0;
        if (!byPosition[pos]) byPosition[pos] = [];
        byPosition[pos].push(el);
      });
      const positions = Object.keys(byPosition).map(Number).sort(function(a, b) { return a - b; });
      const opts = [];
      positions.forEach(function(pos) {
        const els = byPosition[pos];
        let val = null;
        els.forEach(function(el) {
          if (el.tagName === 'SELECT') val = el.value || null;
          else if (el.checked) val = el.value || null;
        });
        opts.push(val);
      });
      return opts;
    }

    function canSelectVariant(v) {
      if (!v) return false;
      // Allow selection if variant is purchasable via normal availability OR backorder/preorder flows.
      return !!v.available || v.inventory_policy === 'continue';
    }

    function findVariant(opts) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (v.option1 === (opts[0] || null) && v.option2 === (opts[1] || null) && v.option3 === (opts[2] || null)) {
          return v;
        }
      }
      return null;
    }

    function updateOptionAvailability(selectedOpts) {
      const opts = selectedOpts || getSelectedOptions();
      variantOptions.forEach(function (el) {
        const pos = parseInt(el.getAttribute('data-option-position'), 10) || 0;
        if (!pos) return;

        if (el.tagName === 'SELECT') {
          Array.prototype.slice.call(el.options || []).forEach(function (optEl) {
            const testOpts = opts.slice();
            testOpts[pos - 1] = optEl.value || null;
            optEl.disabled = !canSelectVariant(findVariant(testOpts));
          });
          return;
        }

        if (el.type === 'radio') {
          const testOpts = opts.slice();
          testOpts[pos - 1] = el.value || null;
          const disabled = !canSelectVariant(findVariant(testOpts));
          el.disabled = disabled;
          if (disabled) el.setAttribute('aria-disabled', 'true');
          else el.removeAttribute('aria-disabled');
        }
      });
    }

    function updateForm(variant) {
      if (!variant) return;
      hiddenId.value = variant.id;
      const variantData = variantPrices[variant.id] || {};
      const sku = variantData.sku || variant.sku || '';
      sectionEl.querySelectorAll('[data-pdp-sku-wrapper]').forEach(function(wrapper) {
        const skuEl = wrapper.querySelector('[data-pdp-sku]');
        if (!skuEl) return;
        skuEl.textContent = sku || wrapper.getAttribute('data-empty-sku') || '';
      });

      const mediaGallery = document.querySelector('#tw-gallery-tw-main-product-' + sectionId);
      if (mediaGallery && typeof mediaGallery.goToSlide === 'function') {
        // Shopify `product | json` may expose variant media as `featured_media` or `featured_image`.
        if (variant.featured_media && variant.featured_media.position) {
          mediaGallery.goToSlide(variant.featured_media.position - 1);
        } else if (variant.featured_image && variant.featured_image.id) {
          const target = mediaGallery.querySelector('[data-media-id="' + String(variant.featured_image.id) + '"]');
          const idx = target ? parseInt(target.getAttribute('data-slide-index'), 10) : NaN;
          if (!Number.isNaN(idx)) mediaGallery.goToSlide(idx);
        }
      }
      if (priceEl && variantPrices[variant.id]) {
        const prices = variantPrices[variant.id];
        const priceSpan = priceEl.querySelector('.tw-product-price');
        if (priceSpan) priceSpan.textContent = prices.price;
        const compare = priceEl.querySelector('.tw-line-through');
        if (compare) {
          if (variant.compare_at_price > variant.price && prices.compare_at_price) {
            compare.textContent = prices.compare_at_price;
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? (addToCartLabel || 'Add to cart') : (soldOutLabel || 'Sold out');
      }
      sectionEl.querySelectorAll('.tw-pdp-buy-buttons__add').forEach(function(btn) {
        if (btn === submitBtn) return;
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? (btn.getAttribute('data-add-to-cart') || 'Add to cart') : (btn.getAttribute('data-sold-out') || 'Sold out');
      });
      const stickyPrice = sectionEl.querySelector('#tw-sticky-bar-price-' + sectionId);
      const stickyAdd = sectionEl.querySelector('#tw-sticky-bar-add-' + sectionId);
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (stickyPrice && variantPrices[variant.id]) stickyPrice.textContent = variantPrices[variant.id].price;
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? (stickyAdd.getAttribute('data-add-to-cart') || 'Add to cart') : (stickyAdd.getAttribute('data-sold-out') || 'Sold out');
      }
      if (stickyVariantSelect) stickyVariantSelect.value = String(variant.id);
      var dynamicCheckout = sectionEl.querySelector('[data-dynamic-checkout-wrapper]');
      if (dynamicCheckout) dynamicCheckout.style.display = variant.available ? '' : 'none';
    }

    function syncStickyQuantityFromForm() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) stickyQty.value = mainQty.value;
    }
    function syncFormQuantityFromSticky() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    }

      const triggerEl = sectionEl.querySelector('.tw-buy-buttons-trigger');
      const stickyBar = sectionEl.querySelector('.tw-sticky-add-cart');
      if (triggerEl && stickyBar) {
      const basePaddingBottom = parseFloat(window.getComputedStyle(sectionEl).paddingBottom) || 0;
      var stickyBarHeight = 80;
      var stickySpacingReserved = false;

      function getStickyReserveHeight() {
        var rect = stickyBar.getBoundingClientRect();
        var height = Math.ceil(rect.height || stickyBar.offsetHeight || stickyBarHeight || 0);
        if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) {
          var bottom = parseFloat(window.getComputedStyle(stickyBar).bottom) || 0;
          height += Math.max(0, Math.ceil(bottom));
        }
        return height;
      }

      function updateStickyMeasurements() {
        stickyBarHeight = Math.max(1, getStickyReserveHeight());
        if (stickySpacingReserved) {
          sectionEl.style.paddingBottom = (basePaddingBottom + stickyBarHeight) + 'px';
        }
      }

      function reserveStickySpacing(visible) {
        updateStickyMeasurements();
        stickySpacingReserved = !!visible;
        if (stickySpacingReserved) {
          sectionEl.style.paddingBottom = (basePaddingBottom + stickyBarHeight) + 'px';
        } else {
          sectionEl.style.paddingBottom = basePaddingBottom + 'px';
        }
      }

      syncStickyQuantityFromForm();
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (stickyVariantSelect) {
        stickyVariantSelect.addEventListener('change', function() {
          const vid = parseInt(this.value, 10);
          const v = product.variants.find(function(x) { return x.id === vid; });
          if (v) updateForm(v);
        });
      }
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (stickyQty) {
        stickyQty.addEventListener('change', syncFormQuantityFromSticky);
        stickyQty.addEventListener('input', syncFormQuantityFromSticky);
        sectionEl.querySelectorAll('.tw-sticky-qty-minus, .tw-sticky-qty-plus').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var n = parseInt(stickyQty.value, 10) || 1;
            if (btn.classList.contains('tw-sticky-qty-minus')) n = Math.max(1, n - 1);
            else n = Math.min(99, n + 1);
            stickyQty.value = n;
            syncFormQuantityFromSticky();
          });
        });
      }
      const mainQtyInput = form.querySelector('input[name="quantity"]');
      if (mainQtyInput) {
        mainQtyInput.addEventListener('change', syncStickyQuantityFromForm);
        mainQtyInput.addEventListener('input', syncStickyQuantityFromForm);
      }
      form.addEventListener('click', function(e) {
        if (e.target.closest('[data-qty-minus], [data-qty-plus]')) setTimeout(syncStickyQuantityFromForm, 0);
      });

      let stickyVisible = false;
      const footerEl = document.querySelector('footer.tw-footer');
      function onScroll() {
        updateStickyMeasurements();
        const triggerRect = triggerEl.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        var footerNear = false;
        if (footerEl) {
          var footerRect = footerEl.getBoundingClientRect();
          footerNear = footerRect.top < viewportHeight - stickyBarHeight;
        }
        if (footerNear) {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); reserveStickySpacing(false); stickyVisible = false; }
          return;
        }
        if (triggerRect.bottom <= 0) {
          if (!stickyVisible) { stickyBar.classList.add('tw-translate-y-0'); stickyBar.classList.remove('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'false'); reserveStickySpacing(true); stickyVisible = true; }
        } else {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); reserveStickySpacing(false); stickyVisible = false; }
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if (window.ResizeObserver) {
        var stickyResizeObserver = new ResizeObserver(onScroll);
        stickyResizeObserver.observe(stickyBar);
      }
      onScroll();
      const stickyAddBtn = sectionEl.querySelector('.tw-sticky-bar-add');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function() {
          if (form && !stickyAddBtn.disabled) form.requestSubmit();
        });
      }
    }

    variantOptions.forEach(function(el) {
      el.addEventListener('change', function() {
        const opts = getSelectedOptions();
        const variant = findVariant(opts);
        updateForm(variant);
        setSelectedLabels(opts);
        updateOptionAvailability(opts);
      });
    });
    var currentVariantId = hiddenId && parseInt(hiddenId.value, 10);
    if (currentVariantId && product && product.variants) {
      var currentVariant = product.variants.find(function(v) { return v.id === currentVariantId; });
      if (currentVariant) updateForm(currentVariant);
    }
    var initialOpts = getSelectedOptions();
    setSelectedLabels(initialOpts);
    updateOptionAvailability(initialOpts);
    }); // end sections.forEach
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-media-gallery-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-mgs]');
    if (!section || !section.querySelector('[data-tw-mgs-list]')) return;
    var list = section.querySelector('[data-tw-mgs-list]');
    var slides = section.querySelectorAll('[data-tw-mgs-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    section.querySelector('[data-tw-mgs-prev]') && section.querySelector('[data-tw-mgs-prev]').addEventListener('click', function() { goTo(index - 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    section.querySelector('[data-tw-mgs-next]') && section.querySelector('[data-tw-mgs-next]').addEventListener('click', function() { goTo(index + 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    goTo(0);
    if (autoplay && total > 1) timer = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-minicart-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function loadUpsells() {
      document.querySelectorAll('.tw-cart-upsell--fetch').forEach(function(el) {
        if (!el.dataset.url) return;
        if (el.dataset.loaded) return;
        var grid = el.querySelector('.tw-cart-upsell__grid');
        if (!grid) return;
        el.dataset.loaded = 'true';
        fetch(el.dataset.url)
          .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function(html) {
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
            var sectionEl = wrap.querySelector('#shopify-section-' + sectionId + ' .tw-cart-upsell__grid');
            if (!sectionEl && wrap.querySelector('.tw-cart-upsell__grid')) sectionEl = wrap.querySelector('.tw-cart-upsell__grid');
            if (sectionEl && sectionEl.innerHTML.trim()) {
              grid.innerHTML = sectionEl.innerHTML;
              grid.classList.remove('tw-cart-upsell__grid--placeholder');
            } else {
              el.style.display = 'none';
            }
          })
          .catch(function() { el.style.display = 'none'; });
      });
    }
    
    loadUpsells();
    
    document.addEventListener('cart:drawer-open', loadUpsells);
    var cartDrawer = document.querySelector('[data-drawer]');
    if (cartDrawer) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' || mutation.attributeName === 'class') {
            var isOpen = cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('open') || cartDrawer.classList.contains('is-open');
            if (isOpen) loadUpsells();
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-pickup-availability"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-tw-pickup-drawer]') && document.querySelector('[data-tw-pickup-drawer]').closest('.tw-pickup-availability');
    if (!section) return;
    const trigger = section.querySelector('[data-tw-pickup-trigger]');
    const drawer = section.querySelector('[data-tw-pickup-drawer]');
    const closeBtns = section.querySelectorAll('[data-tw-pickup-close]');
    function open() {
      if (drawer) drawer.classList.remove('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (drawer) drawer.classList.add('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (trigger) trigger.addEventListener('click', open);
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    if (drawer) drawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.querySelector('[data-tw-sb]');
    if (!wrap || !wrap.querySelector('[data-tw-sb-list]')) return;
    var list = wrap.querySelector('[data-tw-sb-list]');
    var slides = wrap.querySelectorAll('[data-tw-sb-slide]');
    var n = slides.length;
    if (n <= 0) return;
    var idx = 0;
    var autoplay = wrap.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(wrap.getAttribute('data-speed'), 10) || 5000;
    var t = null;
    function go(i) {
      idx = (i + n) % n;
      list.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }
    function next() { go(idx + 1); }
    if (wrap.querySelector('[data-tw-sb-prev]')) wrap.querySelector('[data-tw-sb-prev]').addEventListener('click', function() { go(idx - 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    if (wrap.querySelector('[data-tw-sb-next]')) wrap.querySelector('[data-tw-sb-next]').addEventListener('click', function() { go(idx + 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    go(0);
    if (autoplay && n > 1) t = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(section) {
      if (!section || !section.querySelector('[data-tw-slideshow-list]')) return;
      if (section.dataset.twSlideshowInited === '1') return;
      section.dataset.twSlideshowInited = '1';

      var list = section.querySelector('[data-tw-slideshow-list]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-tw-slide]'));
      var total = slides.length;
      if (total <= 0) return;

      var index = 0;
      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
      var timer = null;

      function markActive() {
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', j === index);
        });
        section.querySelectorAll('[data-tw-dot]').forEach(function(btn, j) {
          if (j === index) btn.setAttribute('aria-current', 'slide');
          else btn.removeAttribute('aria-current');
        });
      }

      function goTo(i) {
        index = (i + total) % total;
        list.style.transform = 'translateX(-' + (index * 100) + '%)';
        markActive();
      }

      function next() { goTo(index + 1); }

      function startAutoplay() {
        if (timer) clearInterval(timer);
        if (autoplay && total > 1) timer = setInterval(next, speed);
      }

      var prev = section.querySelector('[data-tw-slide-prev]');
      var nextBtn = section.querySelector('[data-tw-slide-next]');
      if (prev) prev.addEventListener('click', function() { goTo(index - 1); startAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(index + 1); startAutoplay(); });
      section.querySelectorAll('[data-tw-dot]').forEach(function(btn, i) {
        btn.addEventListener('click', function() { goTo(i); startAutoplay(); });
      });

      goTo(0);
      startAutoplay();
    }

    document.querySelectorAll('[data-tw-slideshow]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e && e.target) {
        e.target.querySelectorAll('[data-tw-slideshow]').forEach(init);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
